import { Injectable } from '@angular/core';
import { Subject, interval } from 'rxjs';
import { FS3Notification } from '../objects/notification';
import { debounce } from 'rxjs/operators';
import { UploadItem } from 'app/objects/uploadItem';
import {File} from "../objects/file";
import {JobsListItem} from "../objects/jobs";
import {AppEvent} from "../objects/appEvent";

@Injectable({
  providedIn: 'root'
})

export class SharedDataService {
  public get sortOrder(): string {
    //return this._sortOrder ? this._sortOrder : SharedDataService.SORT_DIRECTIONS.NAME_ASC;
    // todo: fix this default => use value from listing model
    return this._sortOrder ? this._sortOrder : SharedDataService.SORT_DIRECTIONS.DATE_DESC;
  };
  public set sortOrder(value: string) {
    this._sortOrder = value;
    this.sortOrderSource.next(value)
    localStorage.setItem('sortOrder', value)
  };

  public static readonly SORT_DIRECTIONS = {
    NAME_ASC: 'name_asc',
    NAME_DESC: 'name_desc',
    SIZE_ASC: 'size_asc',
    SIZE_DESC: 'size_desc',
    DATE_ASC: 'date_asc',
    DATE_DESC: 'date_desc',
    POINTS_ASC: 'points_asc',
    POINTS_DESC: 'points_desc',
  };
  private _sortOrder: string;
  private sortOrderSource = new Subject<string>();
  public sortOrderObservable$ = this.sortOrderSource.asObservable();

  public uploadProgress = 0;
  private uploadProgressSubject = new Subject<number>();
  public uploadProgressObservable = this.uploadProgressSubject.asObservable()

  private notificationsSource = new Subject<FS3Notification>();
  public notificationsObservable$ = this.notificationsSource.pipe(debounce(ev => interval(500)));

  private globalEventSource = new Subject<AppEvent>();
  public globalEventObservable$ = this.globalEventSource.asObservable();

  private updateListSource = new Subject<string>();
  public updateListObservable = this.updateListSource.pipe(debounce(ev => interval(1000)));

  private closeUploaderSource = new Subject<boolean>();
  public closeUploaderObservable = this.closeUploaderSource.asObservable();

  private addFileToListSource = new Subject<UploadItem>();
  public addFileToListObservable = this.addFileToListSource.asObservable();

  private addFileToListFixedSource = new Subject<File[]>();
  public addFileToListFixedObservable = this.addFileToListFixedSource.asObservable();

  private jobResolvedSource = new Subject<JobsListItem>();
  public jobResolvedObservable = this.jobResolvedSource.asObservable();

  constructor() {

    const savedOrder = localStorage.getItem('sortOrder');
    if (savedOrder) {
      this.sortOrder = savedOrder;
    }
  }

  public updateProgress(progress: number): void {
    this.uploadProgressSubject.next(progress)
    if (progress >= 100) {
      this.pushNotification({ text: 'The files were successfully uploaded.', type: 'success' })
      this.uploadProgressSubject.next(-1)
    }
  }

  public pushAppEvent(appEvent: AppEvent) {
    this.globalEventSource.next(appEvent)
  }
  public pushNotification(notification: FS3Notification) {
    console.log('pushNotification', notification, this.notificationsSource);
    this.notificationsSource.next(notification)
  }
  public updateList(path) {
    this.updateListSource.next(path)
  }
  public closeDialog(value) {
    this.closeUploaderSource.next(value)
  }

  // todo: refactor to use strict type
  // Add file from upload
  public addFileToList(file) {
    this.addFileToListSource.next(file)
  }

  public addFilesToListFixed(files: File[]) {
    this.addFileToListFixedSource.next(files)
  }

  public jobResolved(job: JobsListItem) {
    this.jobResolvedSource.next(job)
  }

}
